import { Anchor, Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";

type Ref = string | { _id?: string; id?: string } | null | undefined;

function refId(r: Ref): string | undefined {
  if (!r) return undefined;
  return typeof r === "string" ? r : r._id ?? r.id;
}

/** Driver name (or id) linking to /drivers/:id. */
export function DriverLink({
  driver,
  name,
}: {
  driver?: Ref;
  name?: string;
}) {
  const navigate = useNavigate();
  const id = refId(driver);
  const label = name ?? (id ? id.slice(-8) : undefined);
  if (!id || !label)
    return (
      <Text span size="sm" c="dimmed">
        {label ?? "—"}
      </Text>
    );
  return (
    <Anchor
      size="sm"
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/drivers/${id}`);
      }}
    >
      {label}
    </Anchor>
  );
}

/** Rider/user name (or id) linking to /users/:id. */
export function UserLink({ user, name }: { user?: Ref; name?: string }) {
  const navigate = useNavigate();
  const id = refId(user);
  const label = name ?? (id ? id.slice(-8) : undefined);
  if (!id || !label)
    return (
      <Text span size="sm" c="dimmed">
        {label ?? "—"}
      </Text>
    );
  return (
    <Anchor
      size="sm"
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/users/${id}`);
      }}
    >
      {label}
    </Anchor>
  );
}
